import { useBehavior } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TZendeskChat } from '../../types/data';
import { TButtonOption } from '../../types/options';
import { ZendeskChatView } from './ZendeskChatView';
import { getZendeskScriptSrc } from './zendeskUtils';

/**
 * The chat script src is built from the server-provided `zendeskKey` (ZendeskChatWidget contract).
 * When the key is not received, the Global variable with the full script URL is used instead:
 *  example: NX_PUBLIC_GLOBAL_zendeskChatApiKey='https://static.zdassets.com/ekr/snippet.js?key=561d898d-1496-4cd1-9e'
 */
export const ZendeskChat = ({ widget }: TWidgetProps<TZendeskChat, TButtonOption>) => {
    const label = widget.data?.messages?.label ?? widget.data?.label;
    const { iconName = 'ic_life_buoy', margin } = widget.options ?? {};
    const { zendeskKey, zendeskToken, extras, conversationId } = widget.data ?? {};

    const zendeskScriptSrc = getZendeskScriptSrc(zendeskKey);
    const { isDisabled, isHidden } = useBehavior(widget);
    const parentStyleNames = [widget.options?.style ?? ' '].filter(Boolean) as string[];

    return (
        <ZendeskChatView
            uid={widget.uid}
            widget={widget}
            isDisabled={isDisabled}
            isHide={isHidden}
            label={label}
            iconName={iconName}
            parentStyleNames={parentStyleNames}
            margin={margin}
            isFloatButton={false}
            zendeskScriptSrc={zendeskScriptSrc}
            zendeskToken={zendeskToken}
            extras={extras}
            conversationId={conversationId}
        />
    );
};
